<template>
  <div class="admin_center_settings">
    <div class="container" style="background:rgba(255,255,255,.92); padding:20px 0;">
      <b-container class="form fluid">
        <b-card class="text-center">
          <h5>Homepage News</h5>
          <p style="max-width:650px; margin:20px auto 15px; color:#666;">
            Edit the homepage news HTML for a center. The homepage will render this content as HTML.
          </p>
          <p style="max-width:650px; margin:0 auto 30px; color:#666; font-size:12px;">
            Example: &lt;p&gt;Open play is back this Friday.&lt;/p&gt;&lt;p&gt;&lt;a href=&quot;/booking/events&quot;&gt;View calendar&lt;/a&gt;&lt;/p&gt;
          </p>

          <p style="max-width:220px; margin:auto;">
            <label class="placeholder">
              <b-form-input v-model.trim="center_id" type="number" min="1" placeholder=" "></b-form-input>
              <span>Center ID *</span>
              <p>Current center to load and save</p>
            </label>
          </p>

          <div style="margin:20px auto 0; max-width:850px; text-align:left;">
            <label style="font-size:13px; color:#666;">News HTML</label>
            <b-form-textarea
              v-model="bu_news"
              rows="14"
              max-rows="22"
              placeholder="Enter homepage HTML here"
            ></b-form-textarea>
          </div>

          <div style="margin-top:25px;">
            <b-button variant="outline-secondary" @click="loadSettings" :disabled="loading">Load</b-button>
            <b-button variant="outline-primary" @click="saveSettings" :disabled="saving" style="margin-left:10px;">Save</b-button>
          </div>

          <div style="margin:35px auto 0; max-width:850px; text-align:left;">
            <h6>Preview</h6>
            <div v-if="bu_news.trim() === ''" class="preview_box preview_placeholder">No homepage news yet.</div>
            <div v-else class="preview_box" v-html="bu_news"></div>
          </div>
        </b-card>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      center_id: '1',
      bu_news: '',
      loading: false,
      saving: false,
    }
  },
  mounted () {
    this.loadSettings();
  },
  methods: {
    loadSettings() {
      if (this.center_id.trim() === '' || parseInt(this.center_id) <= 0) {
        alert('Center ID must be a positive number.');
        return;
      }

      this.loading = true;
      this.$http.get('/api/center_settings?center_id=' + parseInt(this.center_id)
      ).then((resp) => {
        this.bu_news = resp.data.bu_news || '';
      }).catch((error) => {
        alert(error.response.data.message);
        console.log(error.response.data.message);
        console.log(error.response.status);
        console.log(error.response.headers);
      }).finally(() => {
        this.loading = false;
      })
    },
    saveSettings() {
      if (this.center_id.trim() === '' || parseInt(this.center_id) <= 0) {
        alert('Center ID must be a positive number.');
        return;
      }

      this.saving = true;
      this.$http.post('/api/admin/center_settings', {
        center_id: parseInt(this.center_id),
        bu_news: this.bu_news,
      }).then(() => {
        alert('Homepage news saved.');
      }).catch((error) => {
        alert(error.response.data.message);
        console.log(error.response.data.message);
        console.log(error.response.status);
        console.log(error.response.headers);
      }).finally(() => {
        this.saving = false;
      })
    },
  },
}
</script>

<style scoped lang="scss">
* {
  font-family: 'Montserrat';
  box-sizing: border-box;
  color: #8b8c8d;
}

input, textarea {
  position: relative;
  outline: none;
  outline: 0px !important;
  -webkit-appearance: none;
  box-shadow: none !important;
  display: block;
  box-sizing: border-box;
  width: 100%;
  font-size: 13px;
  line-height: 1.8;
  border: 1px solid #dddedf;
  padding: 8px 10px;
  font-family: inherit;
}

.placeholder {
  width: 100%;
  position: relative;
}

.placeholder > span {
  position: absolute;
  left: 10px;
  top: -10px;
  background: #fff;
  padding: 0 6px;
  font-size: 10px;
}

.placeholder > p {
  margin-top: 6px;
  font-size: 11px;
}

.preview_box {
  min-height: 160px;
  border: 1px solid #dddedf;
  padding: 15px;
  white-space: normal;
  background: #fafafa;
  color: #333;
}

.preview_placeholder {
  white-space: pre-wrap;
}
</style>
